import { useEffect, useState } from 'react';

const useTabs = ({ initialValue, items }) => {
  const [itemsLength, setItemsLength] = useState(items.length);
  const [value, setValue] = useState(initialValue);

  useEffect(() => {
    setValue(() => initialValue);
  }, [initialValue]);

  useEffect(() => {
    if (itemsLength > items.length) {
      setValue(() => initialValue);
    }

    setItemsLength(items.length);
  }, [items.length]);

  const handleChange = (_, newValue) => {
    setValue(newValue);
  };

  return {
    value,
    handleChange,
  };
};

export default useTabs;
